import api from '@http/api';


export interface IGetAllProjetoByPerfil {
  projetoId: number;
  projetoNome: string;
}

export interface ILista {
  //tipoContribuicao: string;
  documentoImposto: string;
  linkS3: string;
  dataInserida: string;
  ano: string;
  fundoNome: string;
  projetoNome: string;
}

export interface IDocumento {
  id: number;
  descricao: string;
}

export interface IAno {
  id: number;
  descricao: string;
}

class Services {
  public async ImporteDestinacao(data: any) {
    return await api
      .post<any>('/api/ContribuicoesDarf/UploadDocumento', data)
      .then(response => {
        return {
          error: false,
          response: response.data,
        };
      })
      .catch(error => {
        return {
          error: true,
          response: [],
        };
      });
  }


  public async loadGetAllProjetosByPerfil(idPerfil: number) {
    return await api
      .get<IGetAllProjetoByPerfil[]>(`/api/ContribuicoesDarf/ProjetosPorPerfil?perfilId=${idPerfil}`)
      .then(response => {
        return {
          error: false,
          response: response.data,
        };
      })
      .catch(error => {
        return {
          error: true,
          response: [],
        };
      });
    }

}
export default Services;
